"use client";

import Button from "@marginly/ui/components/button";
import T from "@marginly/ui/components/typography";
import { ConsentModal } from "@marginly/ui/features/terms-and-conditions/consent-modal";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { Chain } from "viem";
import { useAccount, useDisconnect, useSignMessage } from "wagmi";

import { MAIN_APP_URL } from "@/constants/links";
import { useRx } from "@/contexts/rx";
import {
  trackConnectWalletClick,
  trackDisconnectWalletClick,
  trackLaunchAppClick,
} from "@/util/tracking";

import { LogoutIcon } from "./logout-icon";
import * as S from "./styled";
interface Props {
  apiBaseurl: string;
  chain: Chain;
  chains: Record<string, Chain>;
}
export const LoginHeader = ({ apiBaseurl }: Props) => {
  const { error$ } = useRx();
  // Add state because of hydration errors
  const [isConnect, setConnectStatus] = useState(false);
  const { address } = useAccount();

  useEffect(() => {
    setConnectStatus(Boolean(address));
  }, [address]);

  const web3Modal = useWeb3Modal();
  const { disconnect } = useDisconnect();

  const handleDisconnect = () => {
    trackDisconnectWalletClick();
    disconnect();
  };

  const handleConnect = () => {
    trackConnectWalletClick();
    web3Modal.open();
  };

  return (
    <S.Nav>
      <Link href={"/"}>
        <S.Logo />
      </Link>

      <S.LoginSectionMobile>
        {isConnect ? (
          <Button sm tertiary onClick={handleDisconnect} icon>
            <LogoutIcon />
          </Button>
        ) : null}
        {isConnect ? (
          <a href={MAIN_APP_URL} onClick={trackLaunchAppClick}>
            <S.BrandButton sm secondary>
              <T action>App</T>
            </S.BrandButton>
          </a>
        ) : (
          <S.BrandButton sm secondary onClick={handleConnect}>
            <T action>Connect</T>
          </S.BrandButton>
        )}
      </S.LoginSectionMobile>
      <S.LoginSectionDesktop>
        {isConnect ? (
          <Button md tertiary onClick={handleDisconnect}>
            <T action>Log out</T>
          </Button>
        ) : null}
        {isConnect ? (
          <a href={MAIN_APP_URL} onClick={trackLaunchAppClick}>
            <S.BrandButton md secondary>
              <T action>Go to app</T>
            </S.BrandButton>
          </a>
        ) : (
          <S.BrandButton md secondary onClick={handleConnect}>
            <T action>Connect</T>
          </S.BrandButton>
        )}
      </S.LoginSectionDesktop>

      <ConsentModal
        baseUrl={apiBaseurl}
        onError={error$.next}
        userAddress={address}
        useDisconnect={useDisconnect}
        useSignMessage={useSignMessage}
      />
    </S.Nav>
  );
};
